'use client';

import type { NextPage } from 'next'
import { useRouter } from 'next/navigation'
import styles from './NotLoggedInComponent.module.scss'
import Subtitle from 'componentsUnits/subtitle'
import Button from 'componentsUnits/button'
import Header from 'components/header'
import { Type } from 'types/type'
import { Size } from 'types/size'
import Break from 'componentsUnits/break'
import ColumnComponent from 'componentsUnits/columnComponent'
import RowComponent from 'componentsUnits/row'

interface Props {
  text?: string
  disableBack?: boolean
}
const NotLoggedInComponent: NextPage<Props> = (props: Props) => {
  const router = useRouter()

  return (
    <div className={styles.general_container}>
      <Header disableBack text="Not Logged In" />
      <Break />
      <ColumnComponent centerH centerV padding>
        <Break />
        <img src='/images/people_dance.png' style={{ maxWidth: "100%", width: 350 }} />
        <Break />
        <Break />
        <Subtitle size={Size.xSmall} type={Type.t11} text='To enjoy the full functionality of brizup' />
        <Subtitle size={Size.xSmall} type={Type.t11} text='you will need to login or create an account' />
        <Break size={Size.small} />
        <Subtitle type={Type.t1} size={Size.large} text="IT'S FREE! 😊" />
        <Break size={Size.medium} />

        {props.text && <Subtitle type={Type.t1} size={Size.xSmall} text={props.text} />}

        <Break />

        <RowComponent gap>
          <Button type={"7"} size={Size.xxSmall} text='Log in' onClick={() => router.push('/auth/login')} />
          <Button type={"7"} size={Size.xxSmall} text='Register' onClick={() => router.push('/auth/signupSlider')} />
        </RowComponent>
      </ColumnComponent >
    </div>
  )
}

export default NotLoggedInComponent
